<template>
    <section class="py-20 bg-gradient-to-b from-blue-dark to-[#020E20] relative overflow-hidden">
        <!-- Background candlestick pattern (optional) -->
        <div class="absolute inset-0 opacity-10 pointer-events-none">
            <img v-if="backgroundImage" :src="$asset(backgroundImage, 'public')" class="w-full h-full object-cover" />
        </div>

        <div class="container mx-auto px-4 relative z-10">
            <h2 class="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-12 text-white">
                So denken wir <span class="text-blue">Märkte.</span>
            </h2>

            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <div v-for="(item, index) in items" :key="index" class="bg-white rounded-2xl p-8 flex flex-col items-center gap-6">
                    <h3 class="text-2xl font-bold text-center text-blue-dark" v-html="item.title"></h3>
                    <i :class="[item.icon, 'text-blue text-[120px]']"></i>
                    <p class="text-center text-black text-lg">{{ item.description }}</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
const props = defineProps({
    items: {
        type: Array,
        default: () => []
    },
    backgroundImage: {
        type: String,
        default: ''
    }
});
</script>
